import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Helper to get headers with token and timeout
const getConfig = (token) => ({
    headers: { Authorization: `Bearer ${token}` },
    timeout: 10000 // 10 seconds timeout
});

export const proceduresApi = {
    /**
     * List procedures with filters
     * @param {string} token - Auth token
     * @param {Object} filters - Query parameters (client_id, status, type, etc.)
     */
    listProcedures: async (token, filters = {}) => {
        const params = new URLSearchParams();
        Object.keys(filters).forEach(key => {
            if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
                params.append(key, filters[key]);
            }
        });
        const response = await axios.get(`${API}/procedures?${params.toString()}`, getConfig(token));
        return response.data;
    },

    /**
     * Create a new procedure
     * @param {string} token 
     * @param {Object} payload 
     */
    createProcedure: async (token, payload) => {
        const response = await axios.post(`${API}/procedures`, payload, getConfig(token));
        return response.data;
    },

    /**
     * Get procedure detail
     * @param {string} token 
     * @param {string} id 
     */
    getProcedure: async (token, id) => {
        const response = await axios.get(`${API}/procedures/${id}`, getConfig(token));
        return response.data;
    },

    /**
     * Update procedure
     * @param {string} token 
     * @param {string} id 
     * @param {Object} payload 
     */
    updateProcedure: async (token, id, payload) => {
        const response = await axios.put(`${API}/procedures/${id}`, payload, getConfig(token));
        return response.data;
    },

    /**
     * Close procedure (soft delete/archive)
     * @param {string} token 
     * @param {string} id 
     * @param {string} outcome - 'favorable', 'unfavorable', etc.
     * @param {string} resolutionDate - ISO date string
     */
    closeProcedure: async (token, id, outcome, resolutionDate) => {
        const params = new URLSearchParams({ outcome });
        if (resolutionDate) params.append('resolution_date', resolutionDate);

        const response = await axios.post(
            `${API}/procedures/${id}/close?${params.toString()}`,
            {},
            getConfig(token)
        );
        return response.data;
    },

    /**
     * Get all templates
     * @param {string} token 
     */
    getProcedureTemplates: async (token) => {
        const response = await axios.get(`${API}/procedure-templates`, getConfig(token));
        return response.data;
    },

    /**
     * Get specific template
     * @param {string} token 
     * @param {string} templateKey 
     */
    getProcedureTemplate: async (token, templateKey) => {
        const response = await axios.get(`${API}/procedure-templates/${templateKey}`, getConfig(token));
        return response.data;
    }
};
